namespace $ {
	export function $shm_showcase_fqn( entry: { package: string, path: string, id: string } ) {
		return entry.package === 'mol' ? '$mol_' + entry.id : '$shm_' + entry.path.replace( /\//g, '_' )
	}

	export const $shm_showcase_groups = {
		data: 'Отображение данных',
		layout: 'Контейнеры, расположение',
		input: 'Ввод, выбор, действия',
		complex: 'Комплексные компоненты',
		behavior: 'Поведение и плагины',
	}

	export const $shm_showcase_entries = [
		{
			group: 'layout', id: 'shm_tree', title: 'Дерево',
			description: 'Иерархия с линиями веток и сворачиванием.',
			path: 'tree', demo: 'shm_showcase_demo_tree', readme: 'shm/tree/readme.md', package: 'shm',
		},
		{
			"group": "input",
			"id": "shm_paginator",
			"title": "Числовая пагинация",
			"description": "Номера страниц, многоточия и диапазон записей. Общая пагинация таблиц и списков.",
			"path": "paginator",
			"demo": "shm_showcase_demo_paginator",
			"readme": "shm/paginator/readme.md",
			"package": "shm"
		},
		{
			"group": "data",
			"id": "text",
			"title": "Markdown-текст",
			"description": "Заголовки, ссылки, списки и таблицы из Markdown.",
			"path": "text",
			"demo": "text_demo",
			"readme": "mol/text/text/readme.md",
			"package": "mol"
		},
		{
			"group": "data",
			"id": "text_code",
			"title": "Исходный код",
			"description": "Код с подсветкой синтаксиса и копированием.",
			"path": "text/code",
			"demo": "text_code_demo",
			"readme": "",
			"package": "mol"
		},
		{
			"group": "data",
			"id": "speck",
			"title": "Метка",
			"description": "Короткая отметка или счётчик рядом с содержимым.",
			"path": "speck",
			"demo": "speck_demo",
			"readme": "mol/speck/readme.md",
			"package": "mol"
		},
		{
			"group": "data",
			"id": "portion",
			"title": "Прогресс",
			"description": "Индикатор выполнения операции.",
			"path": "portion",
			"demo": "portion_demo",
			"readme": "mol/portion/readme.md",
			"package": "mol"
		},
		{
			"group": "data",
			"id": "calendar",
			"title": "Календарь месяца",
			"description": "Сетка дней месяца с выделением дат.",
			"path": "calendar",
			"demo": "calendar_demo_simple",
			"readme": "mol/calendar/readme.md",
			"package": "mol"
		},
		{
			"group": "data",
			"id": "avatar",
			"title": "Аватар",
			"description": "Изображение, сгенерированное по идентификатору.",
			"path": "avatar",
			"demo": "avatar_demo",
			"readme": "mol/avatar/readme.md",
			"package": "mol"
		},
		{
			"group": "data",
			"id": "grid",
			"title": "Таблица",
			"description": "Табличные данные и иерархические строки.",
			"path": "grid",
			"demo": "grid_demo",
			"readme": "",
			"package": "mol"
		},
		{
			"group": "data",
			"id": "chart",
			"title": "График",
			"description": "Визуальное сравнение рядов данных.",
			"path": "chart",
			"demo": "chart_demo_simple",
			"readme": "mol/chart/readme.md",
			"package": "mol"
		},
		{
			"group": "data",
			"id": "frame",
			"title": "Iframe",
			"description": "Отображение внешней страницы во фрейме.",
			"path": "frame",
			"demo": "frame_demo",
			"readme": "",
			"package": "mol"
		},
		{
			"group": "layout",
			"id": "book2",
			"title": "Книга страниц",
			"description": "Несколько связанных страниц с горизонтальной прокруткой.",
			"path": "book2",
			"demo": "book2_demo",
			"readme": "mol/book2/readme.md",
			"package": "mol"
		},
		{
			"group": "layout",
			"id": "page",
			"title": "Страница",
			"description": "Заголовок, инструменты, основное содержимое и подвал.",
			"path": "page",
			"demo": "page_demo",
			"readme": "mol/page/readme.md",
			"package": "mol"
		},
		{
			"group": "layout",
			"id": "scroll",
			"title": "Прокрутка",
			"description": "Прокручиваемая область содержимого.",
			"path": "scroll",
			"demo": "scroll_demo",
			"readme": "mol/scroll/readme.md",
			"package": "mol"
		},
		{
			"group": "layout",
			"id": "list",
			"title": "Список",
			"description": "Вертикальный список с виртуальным отображением.",
			"path": "list",
			"demo": "list_demo",
			"readme": "mol/list/readme.md",
			"package": "mol"
		},
		{
			"group": "layout",
			"id": "bar",
			"title": "Группа элементов",
			"description": "Объединение нескольких контролов в один блок.",
			"path": "bar",
			"demo": "bar_demo",
			"readme": "mol/bar/readme.md",
			"package": "mol"
		},
		{
			"group": "layout",
			"id": "gallery",
			"title": "Галерея",
			"description": "Адаптивная раскладка элементов разного размера.",
			"path": "gallery",
			"demo": "gallery_demo",
			"readme": "",
			"package": "mol"
		},
		{
			"group": "layout",
			"id": "labeler",
			"title": "Подпись к содержимому",
			"description": "Заголовок над полем или значением.",
			"path": "labeler",
			"demo": "labeler_demo",
			"readme": "mol/labeler/readme.md",
			"package": "mol"
		},
		{
			"group": "layout",
			"id": "stack",
			"title": "Наложение",
			"description": "Расположение элементов друг поверх друга.",
			"path": "stack",
			"demo": "stack_demo",
			"readme": "mol/stack/readme.md",
			"package": "mol"
		},
		{
			"group": "layout",
			"id": "pop",
			"title": "Всплывающий блок",
			"description": "Содержимое, привязанное к опорному элементу.",
			"path": "pop",
			"demo": "pop_demo",
			"readme": "mol/pop/readme.md",
			"package": "mol"
		},
		{
			"group": "layout",
			"id": "pop_over",
			"title": "Блок при наведении",
			"description": "Всплывающее содержимое при наведении курсора.",
			"path": "pop/over",
			"demo": "pop_over_demo",
			"readme": "",
			"package": "mol"
		},
		{
			"group": "layout",
			"id": "float",
			"title": "Плавающий элемент",
			"description": "Позиционирование элемента при прокрутке.",
			"path": "float",
			"demo": "float_demo",
			"readme": "",
			"package": "mol"
		},
		{
			"group": "layout",
			"id": "section",
			"title": "Секция",
			"description": "Заголовок и связанное с ним содержимое.",
			"path": "section",
			"demo": "section_demo",
			"readme": "mol/section/readme.md",
			"package": "mol"
		},
		{
			"group": "layout",
			"id": "card",
			"title": "Карточка",
			"description": "Блок содержимого со строкой статуса.",
			"path": "card",
			"demo": "card_demo",
			"readme": "mol/card/readme.md",
			"package": "mol"
		},
		{
			"group": "layout",
			"id": "deck",
			"title": "Вкладки",
			"description": "Переключение между панелями содержимого.",
			"path": "deck",
			"demo": "deck_demo",
			"readme": "mol/deck/readme.md",
			"package": "mol"
		},
		{
			"group": "layout",
			"id": "expander",
			"title": "Раскрывающаяся секция",
			"description": "Показ и скрытие содержимого по заголовку.",
			"path": "expander",
			"demo": "expander_demo",
			"readme": "mol/expander/readme.md",
			"package": "mol"
		},
		{
			"group": "layout",
			"id": "toolbar",
			"title": "Панель инструментов",
			"description": "Размещение инструментов с раскрытием панели.",
			"path": "toolbar",
			"demo": "toolbar_demo",
			"readme": "",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "string",
			"title": "Строка",
			"description": "Однострочный ввод текста.",
			"path": "string",
			"demo": "string_demo",
			"readme": "mol/string/readme.md",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "number",
			"title": "Число",
			"description": "Числовое поле с шагом и ограничениями.",
			"path": "number",
			"demo": "number_demo",
			"readme": "mol/number/readme.md",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "textarea",
			"title": "Многострочный текст",
			"description": "Ввод и редактирование нескольких строк.",
			"path": "textarea",
			"demo": "textarea_demo",
			"readme": "mol/textarea/readme.md",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "check_box",
			"title": "Чекбокс",
			"description": "Включение и выключение отдельной опции.",
			"path": "check/box",
			"demo": "check_box_demo",
			"readme": "",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "format",
			"title": "Ввод по маске",
			"description": "Форматирование текста во время ввода.",
			"path": "format",
			"demo": "format_demo",
			"readme": "mol/format/readme.md",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "paginator",
			"title": "Переключение страниц",
			"description": "Переход к следующему и предыдущему значению.",
			"path": "paginator",
			"demo": "paginator_demo",
			"readme": "",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "search",
			"title": "Поиск",
			"description": "Поисковая строка с подсказками и очисткой.",
			"path": "search",
			"demo": "search_demo",
			"readme": "mol/search/readme.md",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "check_list",
			"title": "Список флажков",
			"description": "Выбор нескольких опций из списка.",
			"path": "check/list",
			"demo": "check_list_demo",
			"readme": "",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "switch",
			"title": "Переключатель",
			"description": "Выбор одного варианта набором кнопок.",
			"path": "switch",
			"demo": "switch_demo",
			"readme": "mol/switch/readme.md",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "select",
			"title": "Выбор значения",
			"description": "Выпадающий список с фильтрацией вариантов.",
			"path": "select",
			"demo": "select_demo_colors",
			"readme": "mol/select/readme.md",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "select_list",
			"title": "Множественный выбор",
			"description": "Добавление и удаление выбранных значений.",
			"path": "select/list",
			"demo": "select_list_demo",
			"readme": "",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "date",
			"title": "Дата",
			"description": "Ввод и выбор даты.",
			"path": "date",
			"demo": "date_demo",
			"readme": "mol/date/readme.md",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "pick_time",
			"title": "Время",
			"description": "Ввод и выбор часов и минут.",
			"path": "pick/time",
			"demo": "pick_time_demo",
			"readme": "mol/pick/time/readme.md",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "pick",
			"title": "Открытие попапа",
			"description": "Кнопка с произвольным всплывающим содержимым.",
			"path": "pick",
			"demo": "pick_demo",
			"readme": "mol/pick/readme.md",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "link",
			"title": "Ссылка",
			"description": "Переход по адресу или изменение параметров страницы.",
			"path": "link",
			"demo": "link_demo",
			"readme": "mol/link/readme.md",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "button",
			"title": "Кнопка",
			"description": "Запуск действия; основные и второстепенные варианты.",
			"path": "button",
			"demo": "button_demo",
			"readme": "mol/button/readme.md",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "button_share",
			"title": "Поделиться",
			"description": "Передача ссылки другому приложению.",
			"path": "button/share",
			"demo": "button_share_demo",
			"readme": "",
			"package": "mol"
		},
		{
			"group": "input",
			"id": "lights_toggle",
			"title": "Переключение темы",
			"description": "Выбор светлого или тёмного оформления.",
			"path": "lights",
			"demo": "lights_demo",
			"readme": "mol/lights/readme.md",
			"package": "mol"
		},
		{
			"group": "complex",
			"id": "form",
			"title": "Форма",
			"description": "Поля, проверка заполнения, отправка и результат.",
			"path": "form",
			"demo": "form_demo",
			"readme": "mol/form/readme.md",
			"package": "mol"
		},
		{
			"group": "complex",
			"id": "book2_catalog",
			"title": "Каталог с навигацией",
			"description": "Меню разделов, поиск и связанные страницы.",
			"path": "book2/catalog",
			"demo": "book2_catalog_demo",
			"readme": "mol/book2/catalog/readme.md",
			"package": "mol"
		},
		{
			"group": "complex",
			"id": "map_yandex",
			"title": "Яндекс Карта",
			"description": "Карта с масштабированием и отметками. Требуется доступ к сервису Яндекс Карт.",
			"path": "map/yandex",
			"demo": "map_yandex_demo",
			"readme": "mol/map/yandex/readme.md",
			"package": "mol"
		},
		{
			"group": "complex",
			"id": "video_player",
			"title": "Видеоплеер",
			"description": "Открытие видео, воспроизведение, перемотка и громкость.",
			"path": "video/player",
			"demo": "video_player_demo",
			"readme": "",
			"package": "mol"
		},
		{
			"group": "behavior",
			"id": "speech",
			"title": "Речь",
			"description": "Распознавание и озвучивание речи. Доступность зависит от браузера.",
			"path": "speech",
			"demo": "speech_demo",
			"readme": "",
			"package": "mol"
		},
		{
			"group": "behavior",
			"id": "theme_auto",
			"title": "Автоматическая тема",
			"description": "Настройка и применение цветовой темы к компонентам.",
			"path": "theme",
			"demo": "theme_demo",
			"readme": "",
			"package": "mol"
		},
		{
			"group": "behavior",
			"id": "drag",
			"title": "Перетаскивание",
			"description": "Перенос данных между элементами интерфейса.",
			"path": "drag",
			"demo": "drag_demo",
			"readme": "",
			"package": "mol"
		},
		{
			"group": "data",
			"id": "shm_echarts",
			"title": "ECharts",
			"description": "Интерактивные графики с легендой, подсказками и масштабированием.",
			"path": "echarts",
			"demo": "shm_showcase_demo_echarts",
			"readme": "",
			"package": "shm"
		},
		{
			"group": "input",
			"id": "shm_file_drop",
			"title": "Загрузка файлов",
			"description": "Выбор файла с диска или перетаскиванием.",
			"path": "file/drop",
			"demo": "shm_showcase_demo_file_drop",
			"readme": "",
			"package": "shm"
		},
		{
			"group": "input",
			"id": "shm_period",
			"title": "Период",
			"description": "Выбор начальной и конечной даты.",
			"path": "period",
			"demo": "shm_showcase_demo_period",
			"readme": "",
			"package": "shm"
		},
		{
			"group": "input",
			"id": "shm_check_list",
			"title": "Чекбоксы с выбором всех",
			"description": "Список вариантов с общим переключателем «Все».",
			"path": "check/list",
			"demo": "shm_showcase_demo_check_list",
			"readme": "",
			"package": "shm"
		},
		{
			"group": "input",
			"id": "shm_button_copy",
			"title": "Копирование",
			"description": "Кнопка копирования с подсказкой и подтверждением действия.",
			"path": "button/copy",
			"demo": "shm_showcase_demo_button_copy",
			"readme": "",
			"package": "shm"
		},
		{
			"group": "data",
			"id": "shm_dotsloader",
			"title": "Индикатор загрузки",
			"description": "Анимированные точки во время ожидания.",
			"path": "dotsloader",
			"demo": "shm_showcase_demo_dotsloader",
			"readme": "",
			"package": "shm"
		},
		{
			"group": "complex",
			"id": "shm_list_page",
			"title": "Страница списка",
			"description": "Используйте для страниц списков: поиск, сортировка и «+ Добавить» в общей шапке, а не в содержимом страницы.",
			"path": "list/page",
			"demo": "shm_showcase_demo_list_page",
			"readme": "shm/list/page/readme.md",
			"package": "shm"
		}
	]

}
